import React, { useMemo } from "react";

import { Image, Flex, Checkbox, Button, ActionIcon, Box } from "@mantine/core";

import { CustomColorInput, CustomDataTable } from "@components/custom";
import { ColumnDef } from "@tanstack/react-table";
import { useTable } from "@refinedev/react-table";

// Sample data structure
interface TableData {
  id: string;
  name: string;
  category: string;
  nationality: string;
  image: string;
}

export const TableStylesheet = () => {
  // Sample data
  const data: TableData[] = [
    {
      id: "1",
      name: "Martina Brillante",
      category: "Women",
      nationality: "Italy",
      image: "https://picsum.photos/id/236/200/300",
    },
    {
      id: "2",
      name: "Chris Moore",
      category: "Men",
      nationality: "United Kingdom",
      image: "https://picsum.photos/id/237/200/300",
    },
    {
      id: "3",
      name: "Felix Alonso",
      category: "Men",
      nationality: "Spain",
      image: "https://picsum.photos/id/238/200/300",
    },
  ];

  // Define columns
  const columns = useMemo<ColumnDef<TableData>[]>(
    () => [
      {
        id: "select",
        header: "",
        cell: () => <Checkbox size="xs" />,
        size: 50,
        enableSorting: false,
      },
      {
        id: "image",
        header: "Image",
        cell: ({ row }) => (
          <Image
            src={row.original.image}
            alt="Descriptive text"
            w={50}
            h={50}
            radius="sm"
          />
        ),
        size: 80,
        enableSorting: false,
      },
      {
        accessorKey: "name",
        header: "Name",
        size: 150,
      },
      {
        accessorKey: "category",
        header: "Category",
        size: 120,
      },
      {
        accessorKey: "nationality",
        header: () => (
          <Flex align="center">
            Nationality{" "}
            <ActionIcon size="sm" ml="5px">
              <></>
            </ActionIcon>
          </Flex>
        ),
        size: 180,
      },
      {
        id: "swimcap",
        header: "SwimCap",
        cell: () => <CustomColorInput variant="dark" />,
        size: 120,
        enableSorting: false,
      },
      {
        id: "actions",
        header: "",
        cell: () => (
          <Button
            rightSection={<></>}
            size="sm"
            variant="ghost"
          >
            Action
          </Button>
        ),
        size: 100,
        enableSorting: false,
      },
    ],
    [],
  );

  const {
    getHeaderGroups,
    getRowModel,
    refineCore: { setCurrent, pageCount, current },
  } = useTable({
    refineCoreProps: {
      resource: "table-demo",
      dataProviderName: "default",
      pagination: { pageSize: 10 },
    },
    columns,
    initialState: {
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    manualPagination: true,
    data: data,
  });

  return (
    <Box
      style={{
        width: "100%",
        overflowX: "auto",
        maxWidth: "100%",
      }}
    >
      <CustomDataTable
        getHeaderGroups={getHeaderGroups}
        getRowModel={getRowModel}
        pageCount={pageCount}
        current={current}
        setCurrent={setCurrent}
        pagination={false}
        loadingMessage="Loading table data..."
        errorMessage="Error loading table data"
        emptyMessage="No data available"
        height="auto"
      />
    </Box>
  );
};
